import { useEffect, useState } from 'react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { Drawer } from '@root/shared/ui-kit'

import { openEditProfileFormModalEvent } from './atoms/reatom-edit-profile-form'
import { EditProfileForm } from './edit-profile-form'

type EditProfileModalProps = {}

export const EditProfileDrawer = (_props: EditProfileModalProps) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  useEffect(() => openEditProfileFormModalEvent.onCall(() => setOpen(true)), [])

  return (
    <Drawer
      open={open}
      onOpenChange={setOpen}
      title={t('profile.edit_profile')}
    >
      <Content>
        <EditProfileForm onDone={() => setOpen(false)} />
      </Content>
    </Drawer>
  )
}

const Content = styled.div`
  padding: 20px;
`
